<template>
  <div>
    <UploadTableHead :gridApi="gridApi" v-on:checHead="checHead"></UploadTableHead>
    <div class="flex">
      <div class="flex flex_column w_100">
        <ag-item
            v-on:getGridApi="getGridApi"
            :rowData="rowData"
            :columnDefs="columnDefs"
            v-on:sortChanged="sortChanged"
            :with-tabs="true"
            :with-header="true"
        ></ag-item>
        <Pagination
            :totalNum="totalNum"
            :pageSize="pageSize"
            :sizeChange="sizeChange"
            :currentChange="currentChange"
            :currentPage="page"
        ></Pagination>
      </div>
    </div>
	  <UploadConfirmation ref="confirmation" @confirm="submit"/>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

import AgItem from "@/components/templates/agGrid/AgItem.vue";
import UploadTableHead from "@/components/templates/agGrid/UploadTableHead";
import Pagination from "@/components/templates/common/Pagination.vue";
import PaginationParent from "@/components/templates/common/PaginationParent.vue";

import {receivableApi} from "@/common/api/receivableApi";
import {enumDef} from "@/common/enumDefs";
import {asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import UploadConfirmation from "@/components/templates/seller/UploadConfirmation.vue";
import {wrappers} from "@/common/utils/wrappers";

export default {
  extends: PaginationParent,
  props: {
    tabInfo: Object
  },
  components: { UploadConfirmation, AgItem, UploadTableHead, Pagination },
  data() {
    return {
      rowData: [],
      columnDefs: [],
      gridApi: null,
      sendData: "",
      filters: [],
      isAll: false,
      sorting: [],
    };
  },
  beforeMount() {
    this.setColumnDefs();
    this.getList();
  },
  methods: {
    sortChanged(sortData) {
      this.sorting = sortData;
      this.initPage();
      this.getList();
    },
    checHead(data) {
      let { checkData } = data;
      let idList = [];
      if (checkData && checkData.length > 0) {
        checkData.forEach(item => {
          idList.push(item.id);
        });
      } else {
        return;
      }
      if (data.type === "edit") {
        this.$store.dispatch("setActionPdfList", checkData);

        // this.$store.dispatch("setActionPdfList", this.pafList);
        this.$store.dispatch("setActionPdfDialog", { show: true });
      }
      if (data.type === "del") {
        this.confirmDeletion(idList);
      }
      if (data.type === "share") {
        this.confirmSendToReview(checkData);
      }
    },
    getGridApi(gApi) {
      this.gridApi = gApi;
    },
    confirmDeletion(data) {
      let option = {
        title: "",
        msg: this.$t("UpLoadTable.del.tip"),
        confirmFun: this.delItem,
        params: data
      };
      this.confirmMeg(option);
    },
    delItem(data) {
      let option = wrappers.asArray(data);

      receivableApi
        .deleteOperation(option)
        .then(_ => {
          this.getList();
        })
        .catch(err => {
          this.toast(err);
        });
    },
    confirmSendToReview(data) {
		this.sendData = wrappers.asArray(data);

		this.$refs.confirmation.showWithReceivableIds(this.sendData.map(item => item.id));
    },
    submit(confirmationData) {
        let idList = confirmationData.map(item => item.receivableId);
      receivableApi
        .submitReview(idList)
        .then(() => {
          this.getList();
        })
        .catch(err => {
          this.toast(err);
        });
    },
    setColumnDefs() {
      this.columnDefs = [
        {
          headerName: this.$t("common.status"),
          minWidth: 75,
          maxWidth: 85,
          cellRendererFramework: "ColorStatus",
          cellRendererParams: {
            color: (data) => data.invoiceDocument && data.debtorCompanyId ? enumDef.trafficLight.properties[enumDef.trafficLight.Green] : !data.invoiceDocument ?
                {
                  iconName: "fa-file-o",
                  colorName: "invalid_color"
                } : enumDef.trafficLight.properties[enumDef.trafficLight.Yellow]
          }
        },
        {
          headerName: this.$t("common.debtor"),
          field: "debtorName",
          minWidth: 200,
          nameType: "debtorName",
          idType: "debtorCompanyId",
          cellRendererFramework: "CompanyTem",
          sortable: true,
        },
        {
          headerName: this.$t("common.type"),
          field: "type",
          minWidth: 65,
          maxWidth: 80,
          cellRendererFramework: "EnumAsIcon",
          enumDef: enumDef.receivableType,
          sortable: true,
        },
		{
          headerName: this.$t("common.invoiceNumber"),
          field: "invoiceNumber",
          minWidth: 175,
          sortable: true,
        },
        {
          headerName: this.$t("seller.upload.table.header.invoiceDocument"),
          field: "invoiceDocumentFilename",
          minWidth: 175,
          cellRendererFramework: "FileLink",
          cellRendererParams: {
            fileIdField: "invoiceDocument",
          },
          sortable: true,
        },
        {
          headerName: this.$t("seller.upload.table.header.receivableAmount"),
          headerClass: "align-right",
          field: "amount",
          valueFormatter: asMoneyAmount(),
          cellStyle: {'justify-content': 'flex-end'},
          minWidth: 100,
          maxWidth: 150,
          sortable: true,
        },
        {
          headerName: this.$t("common.ccy"),
          field: "currency",
          minWidth: 75,
          maxWidth: 100,
          sortable: true,
        },
        {
          headerName: this.$t("seller.upload.table.header.invoiceDate"),
          field: "invoiceDate",
          minWidth: 125,
          maxWidth: 175,
          valueFormatter: asLocalizedDate(),
          sortable: true,
        },
        {
          headerName: this.$t("seller.upload.table.header.dueDate"),
          field: "dueDate",
          minWidth: 125,
          maxWidth: 175,
          valueFormatter: asLocalizedDate(),
          sortable: true,
        },
        {
          headerName: this.$t("common.actions"),
          minWidth: 100,
          maxWidth: 125,
          cellRendererFramework: "Operation",
          delFun: this.confirmDeletion,
          setFun: this.confirmSendToReview,
          pinned: "right",
          sortable: false,
        },
        {
          minWidth: 50,
          maxWidth: 50,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          pinned: "right",
        }
      ];

      if (this.upTabType === "waiting") {
        // this.columnDefs.splice
        this.columnDefs = this._.reject(this.columnDefs, item => {
          return item.headerName === this.$t("common.status") || item.checkboxSelection;
        });
      }
      if (this.upTabType === "rejected") {
        // this.columnDefs.splice
        // Reason
        this.columnDefs[this.columnDefs.length - 2] = {
          headerName: this.$t("seller.upload.table.header.rejectReason"),
          field: "rejectReason",
          sortable: false,
          minWidth: 150,
          maxWidth: 250,
          cellRendererFramework: "GeneralShortenedDisplay",
        };
        this.columnDefs[this.columnDefs.length - 1] = {
          headerName: this.$t("common.actions"),
          width: 100,
          sortable: false,
          cellRendererFramework: "Operation",
          pinned: "right",
          delFun: this.confirmDeletion,
          setFun: this.confirmSendToReview
        };
        this.columnDefs.push({
          width: 50,
          checkboxSelection: true,
          pinned: "right",
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
        });

        this.columnDefs = this._.reject(this.columnDefs, item => {
          return (
            item.headerName === this.$t("common.status")
          );
        });
      }
    },
    getList() {
      let postData = {
        columns: [],
        filters: this.filters || [],
        maxResults: this.maxResults,
        offset: this.offset,
        sorting: this.sorting
      };
      this.tabInfo
        .dataApi(postData)
        .then(res => {
          if (res) {
            this.rowData = res.data;
            this.setTotalNum(res.recordsTotal);
            this.$store.dispatch("setActionUpTableData", {
              type: "set",
              data: this.rowData
            });
          }
        })
        .catch(err => {
          console.log("err", err);
          this.toast(err);
        });
    },
  },
  computed: {
    ...mapGetters({ upTabType: "upTabType", pdfDialogShow: "pdfDialogShow" }),
  },
  watch: {
    gridApi() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    pdfDialogShow() {
      if (!this.pdfDialogShow) {
        this.getList();
      }
    },
	  tabInfo() {
    	this.setColumnDefs();
    	this.getList();
	  }
  }
};
</script>
